import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";

interface Props {
  label: string | { firstName: any; lastName: any } | undefined;
  options: any;
  startIcon: any;
}

export default function BasicMenu(props: Props) {
  const { label, options, startIcon } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid>
      <Button
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          gap: "8px",
          color: tokens.Text.General.Secondary,
          backgroundColor: tokens.Background.General.Secondary,
          height: "44px",
          padding: "8px",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: tokens.Background.General.Tertiary
          },
          "&:focus": {
            backgroundColor: tokens.Background.General.Tertiary
          },
          "&:active": {
            backgroundColor: tokens.Background.General.Tertiary
          },
          "&:disabled": {
            backgroundColor: tokens.Background.General.Tertiary
          }
        }}
      >
        {startIcon}
        <Typography showBold variant={"body2"}>
          {label}
        </Typography>
        <KeyboardArrowDownIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: tokens.Background.General.Secondary,
            color: tokens.Text.General.Secondary,
            fontVariant: "h5",
            minWidth: "165px"
          }
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
      >
        {options.map((item: any) =>
          item.isDisabled ? (
            <MenuItem key={item.label} disabled onClick={item.onClick}>
              {item.label}
            </MenuItem>
          ) : (
            <MenuItem
              key={item.label}
              onClick={item.onClick}
              sx={{
                "&:hover": {
                  backgroundColor: tokens.Background.General.Color,
                  color: tokens.Text.General.Color
                }
              }}
            >
              {item.label}
            </MenuItem>
          )
        )}
      </Menu>
    </Grid>
  );
}
